module.exports = __webpack_public_path__ + "media/images/fast-law-logo-color-6eecec7d18d51893b227051f4cb54628.svg";